import React, { useEffect, useState } from "react";
import { connect } from 'react-redux';
import stateMap from "../../../../store/stateMap";
import BlockHeader from "../../../../component/BlockHeader/BlockHeader";
import { useSearchParams, createSearchParams, useNavigate, useLocation, Link } from "react-router-dom";
import { EditInitiativeForm } from '../../../../component/EditInitiative';
import api from '../../../../api';
import _ from "lodash";
import {ReactComponent as SVGleft} from '../../../../assets/arrow-left-3.svg';
import "../style.scss";
import "./style.scss";
import LoginBox from 'component/LoginBox/LoginBox';
import {popinfo} from "component/Fancybox/Fancybox";
import { PageCredential } from "component/PageCredential";


const PageCreateFormInitiative = (props) => {
    
    let [searchParams]                          = useSearchParams();
    const [formDataLoad, setFormDataLoad]       = useState(true);
    const [initiative, setInitiative]           = useState({});
    const [initiativeType, setInitiativeType]   = useState(searchParams.get('type'));
    let navigate                                = useNavigate();

    const InitiativeSave = (initiative) => {

        return navigate({
            pathname    : '/initiative/' + initiative.Slug  
            ,search     : `?${createSearchParams({
                fresh : ''
            })}`
        });

        var settingmember = popinfo('loader', 'Seting-up initiative credential', 'Please wait');

        api('/Role', 'post', {
            InitiativeID        : initiative.InitiativeID
            ,RoleName           : 'General Member'
            ,RequiredApproval   : 0
            ,SortIndex          : 1
        }, 'Bearer ' + props.auth.token)
            .then(() => {

                settingmember.close();

                

                if(['talent', 'other'].indexOf(initiative.InitiativeType) >= 0)
                {
                }
                else
                {
                    navigate({
                        pathname    : '/create/' + initiative.InitiativeType  
                        ,search     : `?${createSearchParams({
                            id : initiative.InitiativeID
                        })}`
                    });
                }

            })
            .catch((error) => {
                popinfo('error', 'Seting-up initiative credential', error, {}, settingmember)
            })

    }

    useEffect(()=>{
        if(props.auth.user)
        {
            if(searchParams.get('id') > 0)
            {
                api('/Initiative', 'get', {
                    id : searchParams.get('id')
                }, 'Bearer ' + props.auth.token)
                .then((response) => {
                    
                    if(response.initiative.length)
                    {
                        setInitiativeType(response.initiative[0].initiativeType);

                        setInitiative(response.initiative[0]);

                        setFormDataLoad(false);
                    }
                    else
                    {
                        popinfo('error', 'Initiative not found', 'The initiative has been deleted or wrong link');
                    }    
                })
            }
            else
            {
                setFormDataLoad(false);
            }
        } 
    }, [props.auth.user])
    

    return (
        <>
            <PageCredential title="Fill Initiative Information"/>
            {
                props.auth.user ?
                <div className="form-initiative-basic container w-800 relative">
                    <span className="registration-back">
                        {
                            !formDataLoad &&
                            <Link to={{
                                pathname : '/create/choose'
                                ,search : `?${createSearchParams({
                                    id : typeof initiative.InitiativeID != 'undefined' ? initiative.InitiativeID : 0
                                })}`
                            }}><SVGleft/> Back</Link>
                        }
                    </span>
                    <div className="text-center">
                        <span className="block text-xs mb-5">3 of {['talent', 'other'].indexOf(initiative.InitiativeType || initiativeType) >= 0 ? '3' : '3' }</span>
                        <BlockHeader title="Describe what initiative you'll be creating." desc="Tell us the details of your initiative. That will include your interest, start and end date of initiative, and others" />
                    </div>
        
                    {
                        formDataLoad ? <span className="skeleton"></span> :
                        <EditInitiativeForm sentInitiative={initiative} InitiativeType={initiativeType} onSave={InitiativeSave} saveText="Create Initiative" />
                    }
                </div> 
                : <LoginBox/>
            }
        </>
    )
}

export default connect(stateMap)(PageCreateFormInitiative);